import { render, staticRenderFns } from "./secondary-action-button.vue?vue&type=template&id=016660bf"
import script from "./secondary-action-button.vue?vue&type=script&lang=js"
export * from "./secondary-action-button.vue?vue&type=script&lang=js"
import style0 from "./secondary-action-button.vue?vue&type=style&index=0&id=016660bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports